module.exports = __webpack_public_path__ + "static/media/weather4.ff4675ed.jpg";